import { CatTableCell } from '@blocks-react/components/TableCell';
import { CatTableHeaderCell } from '@blocks-react/components/TableHeaderCell';
import { CVATableCellProps } from '../../types';

export const CVATableCell = ({
  children,
  isHeader = false,
  isFrozen = false
}: Readonly<CVATableCellProps>) => {
  return isHeader ? (
    <CatTableHeaderCell isFrozen={isFrozen}>{children}</CatTableHeaderCell>
  ) : (
    <CatTableCell isFrozen={isFrozen} tooltip={true}>
      {children}
    </CatTableCell>
  );
};
